export interface ShopErrorTranslation {
  title: string;
  message: string;
}

export type ShopErrorCodes =
  | 'auth.user_exists'
  | 'auth.invalid_credentials'
  | 'auth.unauthenticated'
  | 'auth.unauthorized'
  | 'icare.invalid_voucher_code'
  | 'payment_invalid_voucher_code'
  | 'INTERNAL_SERVER_ERROR'
  | 'entity_not_found'
  | 'auth.credentials_expired'
  | 'invalid_payment_cancelation'
  | 'invalid_wallet_modification'
  | 'existing_processing_payment'
  | 'invalid_order_modification'
  | 'auth.invalid_token'
  | 'peach_card_payment_provider'
  | 'order_expired'
  | 'address_validation_error'
  | 'product_variant_unavailable'
  | 'validation_error'
  | 'address_not_found'
  | 'auth.email_in_use'
  | 'cart_checkout_requirement_exception'
  | 'auth.unregistered_user';

export const SHOP_ERROR_TRANSLATIONS: Record<ShopErrorCodes, ShopErrorTranslation> = {
  cart_checkout_requirement_exception: {
    title: $localize`Cart checkout requirement exception`,
    message: $localize`One or more requirements to checkout has not been met. Please review your cart and try again.`,
  },
  product_variant_unavailable: {
    title: $localize`Product Unavailable`,
    message: $localize`This product is no longer available.`,
  },
  order_expired: {
    title: $localize`:@@Error.Order.Expired.Title:Order expired`,
    message: $localize`:@@Error.Order.Expired.Message:To continue, go through the checkout process again to complete your order.`,
  },
  'auth.invalid_token': {
    title: $localize`:@@Error.Auth.InvalidToken.Title:Token Expired`,
    message: $localize`:@@Error.Auth.InvalidToken.Message:Your token has expired. Please login`,
  },
  invalid_wallet_modification: {
    title: $localize`:@@Error.InvalidWalletModification.Title:Wallet payment error`,
    message: $localize`:@@Error.InvalidWalletModification.Message:We can’t process your wallet payment at the moment.`,
  },
  'auth.invalid_credentials': {
    title: $localize`:@@Error.Auth.InvalidCredentials.Title:Invalid Credentials`,
    message: $localize`:@@Error.Auth.InvalidCredentials.Message:Invalid email address or password. Please try again.`,
  },
  'auth.unregistered_user': {
    title: $localize`:@@Error.Auth.UnregisteredUserException.Title:Unregistered User`,
    message: $localize`:@@Error.Auth.UnregisteredUserException.Message:The entered user details are not associated with an account. Please register to proceed.`,
  },
  'auth.user_exists': {
    title: $localize`:@@Error.Auth.UserExists.Title:User Exists`,
    message: $localize`:@@Error.Auth.UserExists.Message:User already exists. Try and login instead.`,
  },
  'auth.email_in_use': {
    title: $localize`:@@Error.Auth.EmailInUse.Title:Email in use`,
    message: $localize`:@@Error.Auth.EmailInUse.Message:This email address is already associated with another account.`,
  },
  'auth.unauthenticated': {
    title: $localize`:@@Error.Auth.Unauthenticated.Title:User Unauthenticated`,
    message: $localize`:@@Error.Auth.Unauthenticated.Message:Can’t perform this action at this point. User Unauthenticated.`,
  },
  'auth.unauthorized': {
    title: $localize`:@@Error.Auth.Unauthorized.Title:User Unauthorized`,
    message: $localize`:@@Error.Auth.Unauthorized.Message:Can’t perform this action at this point. User Unauthorized.`,
  },
  'icare.invalid_voucher_code': {
    title: $localize`:@@Error.Icare.InvalidVoucherCode.Title:Invalid Voucher Code`,
    message: $localize`:@@Error.Icare.InvalidVoucherCode.Message:Please use a valid voucher code.`,
  },
  payment_invalid_voucher_code: {
    title: $localize`:@@Error.PaymentInvalidVoucherCode.Title:Invalid Voucher Code`,
    message: $localize`:@@Error.PaymentInvalidVoucherCode.Message:Please user a valid voucher code.`,
  },
  INTERNAL_SERVER_ERROR: {
    title: $localize`:@@Error.GenericError.Title:Oops! Something went wrong`,
    message: $localize`:@@Error.GenericError.Message:Please try again or contact us.`,
  },
  entity_not_found: {
    title: $localize`:@@Error.EntityNotFound.Title:Entity not found.`,
    message: $localize`:@@Error.EntityNotFound.Message:Invalid enity id.`,
  },
  'auth.credentials_expired': {
    title: $localize`:@@Error.Auth.CredentialsExpired.Title:Credentials expired.`,
    message: $localize`:@@Error.Auth.CredentialsExpired.Message:Your credentials expired. Please reset your password.`,
  },
  invalid_order_modification: {
    title: $localize`:@@Error.InvalidOrderModification.Title:Something went wrong.`,
    message: $localize`:@@Error.InvalidOrderModification.Message:We were unable to update your bag. Please contact us for assistance.`,
  },
  invalid_payment_cancelation: {
    title: $localize`:@@Error.InvalidPaymentCancelation.Title:Oops!, We can’t cancel your payment at the moment.`,
    message: $localize`:@@Error.InvalidPaymentCancelation.Message:Please try again.`,
  },
  existing_processing_payment: {
    title: $localize`:@@Error.ExistingProcessingPayment.Title:Your previous payment is busy processing.`,
    message: $localize`:@@Error.ExistingProcessingPayment.Message:Thank you for your patience.`,
  },
  peach_card_payment_provider: {
    title: $localize`:@@Error.PeachCardPaymentProvider.Title:Transaction processing.`,
    message: $localize`:@@Error.PeachCardPaymentProvider.Message:Your payment can not be cancelled. Please be patient untill the transaction completes.`,
  },
  address_validation_error: {
    title: $localize`:@@Error.AddressValidationError.Title:Address not found.`,
    message: $localize`:@@Error.AddressValidationError.Message:We could not validate your address. Please update your address or contact us.`,
  },
  validation_error: {
    title: $localize`:@@Error.ValidationError.Title:Validation error.`,
    message: $localize`:@@Error.ValidationError.Message:We could not validate your input. Please update and try again.`,
  },
  address_not_found: {
    title: $localize`Address not found`,
    message: $localize`Try to search a diffrent address or contact us for assistance.`,
  },
};
